/* tslint:disable */
/* eslint-disable */
/**
 * Hyper-Timesheet.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TipiInterventoResponseDTO
 */
export interface TipiInterventoResponseDTO {
    /**
     * 
     * @type {number}
     * @memberof TipiInterventoResponseDTO
     */
    idTipoIntervento?: number;
    /**
     * 
     * @type {string}
     * @memberof TipiInterventoResponseDTO
     */
    descrizione?: string | null;
}

/**
 * Check if a given object implements the TipiInterventoResponseDTO interface.
 */
export function instanceOfTipiInterventoResponseDTO(value: object): value is TipiInterventoResponseDTO {
    return true;
}

export function TipiInterventoResponseDTOFromJSON(json: any): TipiInterventoResponseDTO {
    return TipiInterventoResponseDTOFromJSONTyped(json, false);
}

export function TipiInterventoResponseDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): TipiInterventoResponseDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'idTipoIntervento': json['idTipoIntervento'] == null ? undefined : json['idTipoIntervento'],
        'descrizione': json['descrizione'] == null ? undefined : json['descrizione'],
    };
}

export function TipiInterventoResponseDTOToJSON(json: any): TipiInterventoResponseDTO {
    return TipiInterventoResponseDTOToJSONTyped(json, false);
}

export function TipiInterventoResponseDTOToJSONTyped(value?: TipiInterventoResponseDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'idTipoIntervento': value['idTipoIntervento'],
        'descrizione': value['descrizione'],
    };
}

